var render = function (_h,_vm) {var _c=_vm._c;return _c('el-row',_vm._b({class:_vm.data.staticClass || ''},'el-row',Object.assign({gutter: 10}, _vm.data.attrs),false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }